import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { formatNumber } from "../../../utils/utilityfunc";
import moment from "moment";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
  formattedAmount,
  formattedLongDate2,
  formatTimezoneThenStraight1,
} from "../../../components/common-data/Converts";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../../../components/components-bootstrap/PayoutsTable";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import { CheckCircleIcon, CrossIcon } from "../../../images/icons/icons";

const TabsViewTable = ({
  tbDatas,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  isOneDayTabShow,
  clickedCard,
}) => {
  const { loadingDup } = useSelector((state) => state.common);

  const { allData } = tbDatas || {};
  const iniTbDatas = {
    fullPayments: [],
    partialPayments: [],
    allPayments: [],
    OneDayPayments: {},
  };
  const [payments, setPayments] = useState(iniTbDatas);
  const iniModal = {
    partialModal: false,
    partialInfo: [],
  };
  const [modValues, setModValues] = useState(iniModal);
  const [selectedTab, setSelectedTab] = useState(0);

  const closeModal = () => {
    setModValues(iniModal);
  };

  const onClickRow = (detail) => {
    if (detail?.length > 0) {
      setModValues({
        partialModal: true,
        partialInfo: detail,
      });
    } else {
      toast.error("No Detail Found!");
    }
  };

  const handleTabChange = (index) => {
    setSelectedTab(index);
    setIsPage(0);
  };

  useEffect(() => {
    if (allData) {
      setPayments((prevs) => ({
        ...prevs,
        fullPayments: allData.fullPayments ?? [],
        partialPayments: allData.partialPayments ?? [],
        allPayments: [
          ...(allData.fullPayments ?? []),
          ...(allData.partialPayments ?? []),
        ],
        OneDayPayments: allData.oneDayMembership ?? {},
      }));
    }
  }, [allData]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data" style={{ textDecoration: "underline" }}>
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan",
      formatter: (_, row) => {
        return (
          <>
            {row?.subs_reference_id ||
            row?.subs_reference_id === null ||
            row?.subs_reference_id === undefined ||
            row?.subs_reference_id === "" ? (
              <span
                className="tb-data"
                style={{
                  minWidth: "150px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  rowGap: "7px",
                }}
              >
                <small className="gray">
                  {row?.type === "addon_pt"
                    ? "Addon"
                    : row?.type?.replace(/_/g, " ") || "-"}
                </small>
                {row?.type === "regular"
                  ? row?.plan_name
                  : row?.addon_name || "NA"}
                <small
                  style={{
                    padding: "10px",
                    borderRadius: "4px",
                    color: "#fff",
                    backgroundColor: row?.subs_reference_id
                      ? "#0F67B1"
                      : "#36BA98",
                  }}
                >
                  {row?.subs_reference_id ? "Recurring" : "Non Recurring"}
                </small>
              </span>
            ) : (
              <span className="tb-data minWidth150">
                <small className="gray">
                  {row?.type === "addon_pt"
                    ? "Addon"
                    : row?.type?.replace(/_/g, " ") || "-"}
                </small>
                <br />
                {row?.type === "regular"
                  ? row?.plan_name
                  : row?.addon_name || "NA"}
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (_, row) => {
        const isPartial = row.is_partial === "true";

        return (
          <span className="tb-data minWidth100">
            ₹{formatNumber(row?.price || 0)}{" "}
            <small>
              {" "}
              {isPartial
                ? `(total - ₹${formatNumber(row?.total_price || 0)})`
                : ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "total_online",
      text: "Online/Cash",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            ₹{formatNumber(row?.total_online || 0)}/
            {formatNumber(row?.total_cash || 0)}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row.date_added
              ? moment(new Date(parseInt(row.date_added)))
                  .tz("Asia/Kolkata")
                  .format("DD-MM-YYYY")
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.start_date
              ? formatTimezoneThenStraight1(row.start_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.expire_date
              ? formatTimezoneThenStraight1(row.expire_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Subscription Status",
      formatter: (_, row) => {
        const expireDate = moment(row.expire_date).tz("Asia/Kolkata");
        const today = moment().tz("Asia/Kolkata");
        const isExpired = expireDate.isSameOrBefore(today);

        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background: isExpired ? "#F6EFEF" : "#E2EFD5",
              color: isExpired ? "#F13434" : "#379C00",
            }}
          >
            {isExpired ? (
              <span style={{ color: "red" }}>Expired</span>
            ) : (
              <span style={{ color: "green" }}>Active</span>
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => {
        const pendingPayments = row.payment_details?.filter(
          (x) => x.status === "pending"
        );
        const pendingPaymentsCount = pendingPayments?.length || 0;

        return (
          <span
            className="tb-data"
            style={{
              textDecoration: row.is_partial === "true" ? "underline" : "none",
              fontWeight: row.is_partial === "true" ? "700" : "500",
              cursor: row.is_partial === "true" ? "pointer" : "default",
            }}
            onClick={() =>
              row.is_partial === "true"
                ? onClickRow(row?.payment_details)
                : null
            }
          >
            {row.is_partial === "true" ? "Partial" : "Full"}
            {row.is_partial === "true"
              ? `(${pendingPaymentsCount || 0})`
              : null}
          </span>
        );
      },
    },
    {
      dataField: "payment_source",
      text: "Payment source",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.payment_source || "-"}</span>;
      },
    },
    clickedCard === "today" && {
      dataField: "is_pre_sale",
      text: "Pre Sale",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_pre_sale ? <CheckCircleIcon /> : <CrossIcon />}
          </span>
        );
      },
    },
  ];

  const tbColumnsPartial = [
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data" style={{ textDecoration: "underline" }}>
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan",
      formatter: (_, row) => {
        return (
          <>
            {row?.subs_reference_id ||
            row?.subs_reference_id === null ||
            row?.subs_reference_id === undefined ||
            row?.subs_reference_id === "" ? (
              <span
                className="tb-data"
                style={{
                  minWidth: "150px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  rowGap: "7px",
                }}
              >
                <small className="gray">
                  {row?.type === "addon_pt"
                    ? "Addon"
                    : row?.type?.replace(/_/g, " ") || "-"}
                </small>
                {row?.type === "regular"
                  ? row?.plan_name
                  : row?.addon_name || "NA"}
                <small
                  style={{
                    padding: "10px",
                    borderRadius: "4px",
                    color: "#fff",
                    backgroundColor: row?.subs_reference_id
                      ? "#0F67B1"
                      : "#36BA98",
                  }}
                >
                  {row?.subs_reference_id ? "Recurring" : "Non Recurring"}
                </small>
              </span>
            ) : (
              <span className="tb-data minWidth150">
                <small className="gray">
                  {row?.type === "addon_pt"
                    ? "Addon"
                    : row?.type?.replace(/_/g, " ") || "-"}
                </small>
                <br />
                {row?.type === "regular"
                  ? row?.plan_name
                  : row?.addon_name || "NA"}
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "price",
      text: "Completed/Total Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{formatNumber(row?.price || 0)}/
            {formatNumber(row?.total_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "total_online",
      text: "Online/Cash",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            ₹{formatNumber(row?.total_online || 0)}/
            {formatNumber(row?.total_cash || 0)}
          </span>
        );
      },
    },
    {
      dataField: "payment_details",
      text: "Recent Payment",
      formatter: (_, row) => {
        const pendingPayments =
          row?.payment_details?.length > 0 &&
          row.payment_details.filter(
            (payment) => payment.status === "completed"
          );
        pendingPayments.sort(
          (a, b) => new Date(b.payment_created) - new Date(a.payment_created)
        );
        const recentPaymentCompleted =
          pendingPayments?.length > 0
            ? pendingPayments[0].payment_created
            : null;
        const recentPaymentCompletedAmount =
          pendingPayments?.length > 0 ? pendingPayments[0].amount : null;

        return (
          <span className="tb-data minWidth100 underline">
            <small className="gray">
              ₹{convertThenFormat(recentPaymentCompletedAmount || 0)}
            </small>
            <br />
            {recentPaymentCompleted
              ? formatDateTimezon(recentPaymentCompleted)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "payment_details",
      text: "Next Payment Due",
      formatter: (_, row) => {
        const pendingPayments =
          row?.payment_details?.length > 0 &&
          row.payment_details.filter((payment) => payment.status === "pending");
        pendingPayments.sort((a, b) => new Date(a.date) - new Date(b.date));
        const oldestPendingDate =
          pendingPayments?.length > 0 ? pendingPayments[0].date : null;
        const lastPaymentAmount =
          pendingPayments?.length > 0 ? pendingPayments[0].amount : null;

        const pendingPaymentsCount = parseInt(pendingPayments?.length || 0);

        return (
          <span
            className={`tb-data minWidth100 ${
              pendingPaymentsCount <= 0 ? "" : "underline"
            }`}
          >
            {pendingPaymentsCount <= 0 ? (
              "-"
            ) : (
              <>
                <small className="gray">
                  ₹{convertThenFormat(lastPaymentAmount || 0)}
                </small>
                <br />
                {oldestPendingDate ? convertStraight(oldestPendingDate) : "-"}
              </>
            )}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row.date_added
              ? moment(new Date(parseInt(row.date_added)))
                  .tz("Asia/Kolkata")
                  .format("DD-MM-YYYY")
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.start_date
              ? formatTimezoneThenStraight1(row.start_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.expire_date
              ? formatTimezoneThenStraight1(row.expire_date)
              : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "start_date",
    //   text: "Start/Expire Date",
    //   formatter: (_, row) => {
    //     return (
    //       <span
    //         className="tb-data minWidth250"
    //         style={{ textDecoration: "underline" }}
    //       >
    //         {row?.start_date
    //           ? formatTimezoneThenStraight1(row.start_date)
    //           : "-"}{" "}
    //         <b>TO</b>{" "}
    //         {row?.expire_date
    //           ? formatTimezoneThenStraight1(row.expire_date)
    //           : "-"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "expire_date",
      text: "Subscription Status",
      formatter: (_, row) => {
        const expireDate = moment(row.expire_date).tz("Asia/Kolkata");
        const today = moment().tz("Asia/Kolkata");
        const isExpired = expireDate.isSameOrBefore(today);

        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background: isExpired ? "#F6EFEF" : "#E2EFD5",
              color: isExpired ? "#F13434" : "#379C00",
            }}
          >
            {isExpired ? (
              <span style={{ color: "red" }}>Expired</span>
            ) : (
              <span style={{ color: "green" }}>Active</span>
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => {
        const pendingPayments = row.payment_details?.filter(
          (x) => x.status === "pending"
        );
        const pendingPaymentsCount = pendingPayments?.length || 0;

        return (
          <span
            className="tb-data"
            style={{
              textDecoration: row.is_partial === "true" ? "underline" : "none",
              fontWeight: row.is_partial === "true" ? "700" : "500",
              cursor: row.is_partial === "true" ? "pointer" : "default",
            }}
            onClick={() =>
              row.is_partial === "true"
                ? onClickRow(row?.payment_details)
                : null
            }
          >
            {row.is_partial === "true" ? "Partial" : "Full"}
            {row.is_partial === "true"
              ? `(${pendingPaymentsCount || 0})`
              : null}
          </span>
        );
      },
    },
    {
      dataField: "payment_source",
      text: "Payment source",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.payment_source || "-"}</span>;
      },
    },
    clickedCard === "today" && {
      dataField: "is_pre_sale",
      text: "Pre Sale",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_pre_sale ? <CheckCircleIcon /> : <CrossIcon />}
          </span>
        );
      },
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "amount",
      text: "Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">₹{formatNumber(row?.amount || 0)}</span>
        );
      },
    },
    {
      dataField: "date",
      text: "Due Date ",
      formatter: (_, row) => (
        <span className="tb-data minWidth90">
          {convertStraight(row?.date) || "-"}
        </span>
      ),
    },
    {
      dataField: "payment_created",
      text: "Paid On  ",
      formatter: (_, row) => (
        <span className="tb-data minWidth90">
          {row.payment_created
            ? moment(row.payment_created)
                .tz("Asia/Kolkata")
                .format("DD MMMM YYYY")
            : "-"}
        </span>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 bold"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  const tbColumnOnaDay = [
    {
      dataField: "user_id",
      text: "member Details",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name || "NA"}
            <br />
            <small className="underline lowercase">
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            <small>{row?.gym_name || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 minWidth150"
            style={{
              background: "#cd0909",
              color: "#fff",
              borderRadius: "10px",
            }}
          >
            <small>{row?.plan_name || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{row?.price ? formattedAmount(row.price) : 0}
          </span>
        );
      },
    },
    {
      dataField: "subscription_added",
      text: "Subscription Created On",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formattedLongDate2(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Subscription Start Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.start_date ? convertStraight(row.start_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Subscription Expire Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{
              color: "#D32D2D",
              fontWeight: "700",
            }}
          >
            {row?.expire_date ? convertStraight(row.expire_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "trx_id",
      text: "Transaction ID",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            <small>{`Online/${row?.trx_id}` || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "Subscription Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 minWidth150"
            style={{
              background:
                row?.subscription_status === "active" ? "#379C00" : "#C90808",
              color: "#fff",
            }}
          >
            <small>{row?.subscription_status || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "payment_source",
      text: "Payment source",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.payment_source || "-"}</span>;
      },
    },
    clickedCard === "today" && {
      dataField: "is_pre_sale",
      text: "Pre Sale",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_pre_sale ? <CheckCircleIcon /> : <CrossIcon />}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.partialModal}
        onRequestClose={closeModal}
        contentLabel="Partial Payment Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer paymentDetailsModalContainer">
          <ModalHeadAndClose
            title="Partial Payment Details"
            onClose={closeModal}
          />

          <div className="tbWithoutPagination">
            <PayoutsTable
              dataValues={modValues.partialInfo}
              columnsValues={pmInfoColumns}
            />
          </div>
        </div>
      </Modal>

      <Tabs onSelect={handleTabChange}>
        <TabList>
          <Tab>All Payments</Tab>
          <Tab>Full Payments</Tab>
          <Tab>Partial Payments</Tab>
          {isOneDayTabShow && <Tab>One Day Payments</Tab>}
        </TabList>

        <TabPanel>
          <div className="overflowAuto separatedTable">
            {loadingDup ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={payments.allPayments}
                tableColumns={tbColumns}
                isCustPagi={true}
              />
            )}
          </div>
        </TabPanel>
        <TabPanel>
          <div className="overflowAuto separatedTable">
            {loadingDup ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={payments.fullPayments}
                tableColumns={tbColumns}
                isCustPagi={true}
              />
            )}
          </div>
        </TabPanel>
        <TabPanel>
          <div className="overflowAuto separatedTable mt30">
            {loadingDup ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={payments.partialPayments}
                tableColumns={tbColumnsPartial}
                isCustPagi={true}
              />
            )}
          </div>
        </TabPanel>
        <TabPanel>
          <div className="overflowAuto separatedTable no-border-table mt30">
            {loadingDup ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={
                  payments.OneDayPayments?.data?.length > 0
                    ? payments.OneDayPayments.data
                    : []
                }
                tablePagination={
                  payments.OneDayPayments?.pagination?.length > 0
                    ? payments.OneDayPayments.pagination
                    : []
                }
                tableColumns={tbColumnOnaDay}
                isPage={isPage}
                setIsPage={setIsPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            )}
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
};

export default TabsViewTable;
